import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    isLoading : false,
    productcomission: [],
    totalProductCommission: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    iscloading:false,
    cstatus:"",
    cmessage:"",
    cdetails:{},
    ismloading:false,
    mstatus:"",
    mmessage:"",
    commissions: [],
    dstatus:"",
    dmessage:"",
    
};


const productcomissionListSlice = createSlice({
    name: "productcomissionList",
    initialState,
    reducers:{
        getProductCommissionPending: (state) => {
            state.isLoading = true;
        },
        getProductCommissionSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.productcomission = payload;
            state.cdetails = payload;
           // state.user="slice userData";
            state.error = '';
            console.log("lamha",payload)
        },
        getProductCommissionFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        createProductCommissionPending:(state,action) => {
            state.iscloading=true;
        },
        createProductCommissionSuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createProductCommissionFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },
        getSProductCommissionPending: (state) => {
            state.isLoading = true;
        },
        getSProductCommissionSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.commissions=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSProductCommissionFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        modifyProductCommissionPending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyProductCommissionSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.mmessage="ProductCommission Successfully Updated";
        },
        modifyProductCommissionFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
           // console.log('slice '+payload);
            state.mmessage=payload;
        },
        deleteProductCommissionPending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        deleteProductCommissionSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.dmessage="ProductCommission Successfully Deleted";
        },
        deleteProductCommissionFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },



        approveProductCommissionPending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        approveProductCommissionSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.dmessage="ProductCommission Approved Successfully";
        },
        approveProductCommissionFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },


        rejectProductCommissionPending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        rejectProductCommissionSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.dmessage="ProductCommission Rejected Successfully";
        },
        rejectProductCommissionFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = productcomissionListSlice;

export const { getProductCommissionPending, getProductCommissionSuccess, getProductCommissionFail,getSProductCommissionPending, getSProductCommissionSuccess, getSProductCommissionFail, 
    createProductCommissionPending, createProductCommissionSuccess, createProductCommissionFail,
    modifyProductCommissionPending,modifyProductCommissionSuccess,modifyProductCommissionFail,
    deleteProductCommissionPending,deleteProductCommissionSuccess,deleteProductCommissionFail ,approveProductCommissionPending,approveProductCommissionSuccess,approveProductCommissionFail,rejectProductCommissionPending ,rejectProductCommissionSuccess,rejectProductCommissionFail} = actions;

export default reducer;
